module.exports = __webpack_public_path__ + "static/item--blinds--f5@3x.fc3def08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--blinds--f5@3x.png
// module id = 632
// module chunks = 126511778744290